import request from '../../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comState/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchDataAll = query => {

    var list = request({
        url: 'comState/selectPageAll.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comState/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comState/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comState/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comState/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const uploadExcelTs = formData  => {
    return request({
        url: 'comState/uploadExcelTs.do',
        method: 'post',
        data: formData
    });
};




